import OAuth from 'features/plaid/screens/Oauth/Oauth';
import React from 'react';

// this route is used as the redirect uri for plaid oauth app2app flows
// A user should not actually land on this screen as they should be
// which routed users back to the screen they were on before starting the oauth flow
// This is a fallback in case that deeplink handling fails for some reason
const OAuthScreen = () => {
  return <OAuth />;
};

export default OAuthScreen;
